import * as React from 'react';
import { TeamologyDataService } from '../../../services';
import { ReportTeamologyConfig } from '../../../models';
import { PVAContentHeader, PVAContentBody } from '../../../components';
import { BaseRouteProps } from '../../../interfaces';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { FilterStore } from '../../../stores';
import { Form, Text } from 'react-form';

interface SettingsTeamologyEditState {
    orgId: number;
    reportSettings: ReportTeamologyConfig | undefined;
}

interface SettingsTeamologyProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class SettingsTeamologyView extends React.Component<SettingsTeamologyProps, SettingsTeamologyEditState> {
    private teamologyDataService = new TeamologyDataService(this.props.notificationService);
    private defaultValues = ['INFORMATION GATHERING', 'DECISION-MAKING', 'INFORMATION GATHERING', 'DECISION-MAKING'];

    constructor(props: SettingsTeamologyProps) {
        super(props);

        this.state = {
            orgId: 0,
            reportSettings: undefined
        };
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.setState({
                orgId: this.organization.id,
                reportSettings: undefined
            });

            this.teamologyDataService.getConfig(this.organization).then((settings: ReportTeamologyConfig) => {
                this.setState({
                    reportSettings: settings
                });
            });
        }
    }

    public componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    save(values: any) {
        if (!this.organization) {
            return;
        }
        this.teamologyDataService.updateConfig(this.organization, values).then((success) => {
            this.props.notificationService.addNotification(`Saved successfully.`);
        });
    }

    public render() {
        if (!this.organization) {
            return <div />;
        }

        return (
            <div>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                
                <PVAContentHeader>
                    <div className="title">
                        Teamology Settings <span className="light">for </span>
                        {this.organization && <span>'{this.organization.name}'</span>}
                    </div>
                </PVAContentHeader>

                <PVAContentBody>
                    
                    {this.state.reportSettings && <Form
                        defaultValues={this.state.reportSettings}
                        onSubmit={submittedValues => this.save(submittedValues)}
                    >
                        {formApi => (
                            <form onSubmit={formApi.submitForm} id="entityForm">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <h3>Top Left</h3>
                                        <Text className="form-control" placeholder={this.defaultValues[0]} field="topLeft" id="topLeft" />
                                    </div>
                                    <div className="col-xs-6">
                                        <h3>Top Right</h3>
                                        <Text className="form-control" placeholder={this.defaultValues[1]} field="topRight" id="topRight" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <h3>Bottom Left</h3>
                                        <Text className="form-control" placeholder={this.defaultValues[2]} field="bottomLeft" id="bottomLeft" />
                                    </div>
                                    <div className="col-xs-6">
                                        <h3>Bottom Right</h3>
                                        <Text className="form-control" placeholder={this.defaultValues[3]} field="bottomRight" id="bottomRight" />
                                    </div>
                                </div>

                                <br />
                                <br />

                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        )}
                    </Form>}
                </PVAContentBody>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/teamology/TeamologySettings.tsx